// import webDe from "../images/services/S_websiteDevlop.png";
import webDe from "../components/images/services/S_websiteDevlop.png";

import seo from "../components/images/services/S_seo.png";
import soMedia from "../components/images/services/S_socialMedia.png";
import perM from "../components/images/services/S_performanceMark.png";
import contentD from "../components/images/services/S_content.png";
import onlineR from "../components/images/services/S_onlineRep.png";
const servicesData = [
  {
    slug: "seo",

    hero: {
      badge: "SEO Services",

      title: "Nextoric Digital – SEO Agency in India",

      image: seo,

      description:
        "Nextoric Digital is a full-service SEO agency in India that helps startups, SMEs, and service-based brands grow with organic traffic, clear strategies, and human-centred content.",
    },

    sections: [
      {
        heading: "What We Do",

        content:
          "At Nextoric Digital, we design and execute end-to-end SEO campaigns tailored for the Indian market.",

        points: [
          "Auditing your website and fixing technical SEO issues",

          "Optimising on-page elements: titles, headings, content, internal links, and schema",

          "Building authority through off-page SEO and quality backlinks",

          "Strengthening your local presence with Google Business Profile optimisation and local SEO",

          "Creating and publishing SEO-friendly content that ranks and converts",

          "Tracking rankings, traffic, and conversions with clear monthly reports",
        ],
      },

      {
        heading: "On-Page SEO – Optimise Your Website",

        content:
          "On-page SEO means optimising everything on your website so search engines can understand it and users find it useful.",

        points: [
          "Keyword-optimised content, clear headings, and structured content",

          "Optimised titles, meta descriptions, and URLs",

          "Internal linking, image alt text, schema markup, and mobile-friendliness",

          "Site speed and technical improvements for better Google rankings",
        ],
      },

      {
        heading: "Off-Page SEO – Build Authority & Trust",

        content:
          "Off-page SEO covers all activities outside your website that signal authority and trust to search engines.",

        points: [
          "Build high-quality backlinks from relevant Indian and global websites",

          "Earn brand mentions on blogs, news sites, forums, and industry platforms",

          "Strengthen your social and content presence to support organic growth",

          "Create shareable assets like guides, case studies, and infographics",
        ],
      },

      {
        heading: "Local SEO – Rank in Your City",

        content:
          "Local SEO helps local businesses and service providers appear in location-based searches.",

        points: [
          "Google Business Profile (GBP) optimisation",

          "Local citations and directory listings across India",

          "Location-specific landing pages and local content",

          "Customer reviews and reputation management",
        ],
      },

      {
        heading: "Content Marketing – SEO-Friendly & Human-Centred",

        content:
          "Content is the backbone of every successful SEO strategy. We create human-first, SEO-friendly content tailored to your audience.",

        points: [
          "Answers real user questions in conversational English",

          "Uses keywords naturally and strategically",

          "Builds topic clusters and internal links",

          "AI-assisted but human-edited content",
        ],
      },
    ],

    whyChooseUs: [
      {
        title: "Full-Stack SEO for India",

        description:
          "We cover on-page SEO, off-page SEO, local SEO, and content marketing in one integrated strategy.",
      },

      {
        title: "Transparent, Data-Driven Results",

        description:
          "We track rankings, traffic, and conversions with clear reports focused on real business impact.",
      },

      {
        title: "Long-Term Visibility, Not Quick Fixes",

        description:
          "Our SEO approach builds authority, trust, and sustainable rankings over time.",
      },
    ],

    faq: [
      {
        question: "What do you actually do as an SEO agency in India?",

        answer:
          "We audit websites, fix technical issues, optimise on-page and off-page SEO, manage local SEO, and create SEO-friendly content.",
      },

      {
        question: "Do you only serve clients in Bengaluru?",

        answer:
          "No. We work remotely with businesses across India, including Tier-1 and Tier-2 cities.",
      },

      {
        question: "Is your content written by AI?",

        answer:
          "We use AI tools for assistance, but every piece is human-edited to match your brand voice and user intent.",
      },

      {
        question: "How long does SEO take to work?",

        answer:
          "Most clients see noticeable improvements in 3–6 months depending on competition and website health.",
      },

      {
        question: "Can you help with local SEO for my city?",

        answer:
          "Yes. We optimise Google Business Profile listings, local citations, and location-based content.",
      },

      {
        question: "What is your main keyword focus?",

        answer:
          "We naturally optimise around keywords like 'SEO agency in India' and related long-tail phrases.",
      },
    ],

    cta: {
      title: "Ready to Grow Organically?",

      description:
        "Let’s build a long-term SEO strategy that increases rankings, traffic, and conversions.",

      buttonText: "Book Consultation",
    },

    seo: {
      metaTitle: "SEO Agency in India | Nextoric Digital",

      metaDescription:
        "Nextoric Digital provides professional SEO services in India including on-page SEO, off-page SEO, local SEO, and content marketing.",
    },
  },
  {
    slug: "website-development",

    hero: {
      badge: "Website Design & Development",

      title: "Nextoric Digital – Website Design and Development Services",
      image: webDe,

      description:
        "Nextoric Digital provides professional website design and development services in India for startups, SMEs, and service-based brands. We build fast, mobile-friendly, and SEO-ready websites that look great, perform well, and convert visitors into leads or customers.",
    },

    sections: [
      {
        heading: "What We Do – Website Design & Development",

        content:
          "As a website design and development agency in India, we handle every stage of your website journey.",

        points: [
          "Discovery & Planning: Understand your goals, audience, and competitors",

          "UI/UX Design: Create clean, intuitive layouts and user-friendly interfaces",

          "Frontend Development: Code responsive layouts using HTML, CSS, JavaScript, and modern frameworks",

          "Backend Development: Build secure, scalable logic and database structures",

          "CMS Integration: Set up WordPress, Shopify, or custom CMS for easy content updates",

          "Testing & Launch: Run performance, compatibility, and SEO checks before going live",
        ],
      },

      {
        heading: "Responsive Website Design Services",

        content:
          "We design mobile-first, responsive websites that look and work perfectly on every device—desktop, tablet, and mobile.",

        points: [
          "Clear navigation and simple user journeys",

          "Fast-loading layouts and optimised images",

          "Brand-aligned colours, fonts, and micro-interactions",

          "Accessibility-friendly design for better usability",
        ],
      },

      {
        heading: "Custom Web Development Services in India",

        content:
          "We build custom websites and web applications tailored to your business needs.",

        points: [
          "Business websites and corporate portals",

          "Service-based agency websites",

          "E-commerce stores and product catalogues",

          "Booking, membership, or lead-generation platforms",
        ],
      },

      {
        heading: "CMS & SEO-Ready Website Development",

        content:
          "We integrate your website with a CMS so you can easily update content without coding.",

        points: [
          "Clean, semantic HTML structure for better SEO",

          "SEO-friendly URLs, headings, and metadata",

          "Fast loading and mobile-optimised performance",

          "Compatibility with Google Analytics and SEO tools",
        ],
      },
    ],

    whyChooseUs: [
      {
        title: "Full-Service Website Design Agency",

        description:
          "We offer end-to-end website design and development services—from planning and UI/UX to coding, testing, and launch.",
      },

      {
        title: "Designed for Conversion",

        description:
          "We focus on user-centred design and clear CTAs so your website converts visitors into enquiries, leads, or sales.",
      },

      {
        title: "Built for SEO & Performance",

        description:
          "All our websites are responsive, fast, and SEO-ready, helping improve rankings and long-term growth.",
      },
    ],

    faq: [
      {
        question: "What website design and development services do you offer?",

        answer:
          "We offer UI/UX design, responsive website development, custom web applications, CMS integration, and SEO-ready website builds for businesses across India.",
      },

      {
        question: "Do you only build websites for Bengaluru brands?",

        answer:
          "No. We work with clients across India, handling website design and development remotely for startups, SMEs, and service-based businesses.",
      },

      {
        question: "Can you redesign my existing website?",

        answer:
          "Yes. We conduct a UX and performance audit of your current site and rebuild it with improved design, speed, and conversions.",
      },

      {
        question: "Do you use WordPress or Shopify?",

        answer:
          "We specialise in custom WordPress builds and Shopify stores, as well as static and custom-coded websites depending on your needs.",
      },

      {
        question: "How long does it take to build a website?",

        answer:
          "Most standard business websites take 4–8 weeks depending on complexity, content readiness, and revisions.",
      },

      {
        question: "What is your main keyword focus?",

        answer:
          "We naturally optimise around phrases like 'website design and development services', 'website design agency in India', and 'web development services India'.",
      },
    ],

    cta: {
      title: "Ready to Build a High-Performing Website?",

      description:
        "Let’s create a fast, SEO-ready, and conversion-focused website for your business.",

      buttonText: "Book Consultation",
    },

    seo: {
      metaTitle: "Website Design and Development Services | Nextoric Digital",

      metaDescription:
        "Professional website design and development services in India including responsive web design, custom development, CMS integration, and SEO-ready websites.",
    },
  },
  {
    slug: "mobile-app-development",

    hero: {
      badge: "Mobile App Development",

      title: "Nextoric Digital – Mobile App Development Services",
      image: webDe,

      description:
        "Nextoric Digital offers professional mobile app development services in India for startups, SMEs, and digital-first brands. We design and build high-performance, user-friendly mobile apps for iOS and Android that support your business goals and long-term growth.",
    },

    sections: [
      {
        heading: "What We Do – Mobile App Development",

        content:
          "As a mobile app development company in India, we handle the full lifecycle of your app from concept to launch and beyond.",

        points: [
          "Researching your target audience, competitors, and use cases",

          "Designing intuitive UI/UX and wireframes for mobile screens",

          "Developing native, hybrid, or cross-platform apps based on your needs",

          "Integrating APIs, databases, and third-party services",

          "Testing for performance, security, and usability",

          "Publishing on Google Play Store and Apple App Store",
        ],
      },

      {
        heading: "iOS & Android App Development",

        content:
          "We specialise in iOS and Android app development for multiple business models and industries.",

        points: [
          "On-demand and marketplace apps",

          "E-commerce and catalog apps",

          "Productivity, SaaS, and B2B tools",

          "Lead-generation and customer-service apps",

          "Apps optimised for performance and device compatibility",
        ],
      },

      {
        heading: "User-Centred App Design (UI/UX)",

        content:
          "We focus on intuitive mobile app design that improves user engagement and retention.",

        points: [
          "Clean layouts, consistent icons, and easy navigation",

          "Optimised onboarding and user journeys",

          "Mobile-first design for multiple screen sizes",

          "Accessibility-friendly layouts and typography",
        ],
      },

      {
        heading: "App Features & Scalable Architecture",

        content:
          "We build scalable mobile applications with modern features and secure infrastructure.",

        points: [
          "User authentication and profile management",

          "Push notifications and in-app messaging",

          "Payment gateway integrations",

          "Real-time updates and location-based services",

          "Analytics dashboards and admin panels",
        ],
      },
    ],

    whyChooseUs: [
      {
        title: "Full-Life Mobile App Approach",

        description:
          "From discovery and design to development, testing, and launch, we manage the complete app development lifecycle.",
      },

      {
        title: "Performance & Security-First",

        description:
          "We prioritise fast loading, low crashes, smooth UX, and secure data handling for reliable app experiences.",
      },

      {
        title: "Aligned with Your Marketing Goals",

        description:
          "Your mobile app is built to support SEO, performance marketing, customer retention, and conversions.",
      },
    ],

    faq: [
      {
        question: "What mobile app development services do you offer?",

        answer:
          "We offer end-to-end mobile app development including UI/UX design, iOS and Android development, API integrations, testing, and app-store deployment.",
      },

      {
        question: "Do you build only native apps or also hybrid apps?",

        answer:
          "We build native iOS and Android apps as well as hybrid and cross-platform applications based on your project needs.",
      },

      {
        question: "Do you only serve clients in Bengaluru?",

        answer:
          "No. We work remotely with startups, SMEs, and digital-first brands across India.",
      },

      {
        question: "Can you build an MVP first and then scale?",

        answer:
          "Yes. We specialise in MVP app development to help validate ideas quickly before scaling with advanced features.",
      },

      {
        question: "How long does mobile app development take?",

        answer:
          "A simple MVP generally takes 3–6 months, while larger feature-rich applications may take 6–9 months or more.",
      },

      {
        question: "What is your main keyword focus?",

        answer:
          "We naturally optimise around phrases like 'mobile app development services', 'mobile app development company in India', and 'iOS and Android app development'.",
      },
    ],

    cta: {
      title: "Ready to Build Your Mobile App?",

      description:
        "Let’s create a scalable, high-performance mobile app that supports your business growth and user engagement.",

      buttonText: "Book Consultation",
    },

    seo: {
      metaTitle: "Mobile App Development Services | Nextoric Digital",

      metaDescription:
        "Professional mobile app development services in India including iOS app development, Android app development, UI/UX design, and scalable mobile applications.",
    },
  },
  {
    slug: "social-media-marketing",

    hero: {
      badge: "Social Media Marketing",

      title: "Nextoric Digital – Social Media Marketing Services",
      image: soMedia,

      description:
        "Nextoric Digital offers professional social media marketing services in India for startups, SMEs, and service-based brands. We help you build a strong social presence, grow engaged followers, and turn social media into a real lead and sales channel.",
    },

    sections: [
      {
        heading: "What We Do – Social Media Marketing",

        content:
          "As a social media marketing agency in India, we handle everything from strategy to execution.",

        points: [
          "Develop a clear social media strategy aligned with your business goals",

          "Manage Facebook, Instagram, LinkedIn, X (Twitter), and YouTube",

          "Create and schedule high-quality posts, reels, and stories",

          "Run targeted ad campaigns and performance tracking",

          "Engage with comments, messages, and reviews",

          "Analyse results and optimise regularly for better ROI",
        ],
      },

      {
        heading: "Organic Social Media Growth",

        content:
          "We focus on organic social media marketing to build a loyal and engaged audience.",

        points: [
          "Create scroll-stopping visuals, carousels, and short-form videos",

          "Plan themed content calendars",

          "Use relevant hashtags and captions to improve reach",

          "Encourage comments, shares, and saves to boost engagement",
        ],
      },

      {
        heading: "Paid Social Media Advertising",

        content:
          "We run data-driven social media ad campaigns across multiple platforms.",

        points: [
          "Facebook & Instagram ads for brand awareness and conversions",

          "LinkedIn ads for B2B and professional-service targeting",

          "X (Twitter) & YouTube ads for awareness and remarketing",

          "Conversion-focused targeting and ad creatives",
        ],
      },

      {
        heading: "Content Creation for Social Media",

        content:
          "We create platform-specific content tailored to each audience and platform.",

        points: [
          "Short-form videos and reels for Instagram and YouTube Shorts",

          "Carousel posts and educational content for Facebook and LinkedIn",

          "Visual brand assets and storytelling captions",

          "Seasonal campaigns and promotional content",
        ],
      },

      {
        heading: "Analytics & Performance Reporting",

        content:
          "We track and analyse your social media performance to improve strategy and ROI.",

        points: [
          "Follower growth, reach, and engagement metrics",

          "Click-throughs, lead form submissions, and website traffic",

          "Conversion tracking and ROI analysis",

          "Clear monthly reports and recommendations",
        ],
      },
    ],

    whyChooseUs: [
      {
        title: "Full-Service Social Media Agency",

        description:
          "We offer strategy, content creation, posting, advertising, and reporting under one roof.",
      },

      {
        title: "Audience-First Approach",

        description:
          "We focus on building trust, engagement, and meaningful connections with real audiences.",
      },

      {
        title: "Aligned with SEO & Website Goals",

        description:
          "Our campaigns are designed to support website traffic, SEO, and lead generation together.",
      },
    ],

    faq: [
      {
        question: "What social media marketing services do you offer?",

        answer:
          "We offer organic social media management, content creation, paid social ads, and performance reporting for businesses across India.",
      },

      {
        question: "Which platforms do you manage?",

        answer:
          "We specialise in Facebook, Instagram, LinkedIn, X (Twitter), and YouTube with platform-specific strategies.",
      },

      {
        question: "Do you only serve clients in Bengaluru?",

        answer:
          "No. We work remotely with startups, SMEs, and service brands across India.",
      },

      {
        question: "Can you run only ads or only organic posts?",

        answer:
          "Yes. You can choose fully managed social media, only organic content, or only paid advertising.",
      },

      {
        question: "How long does it take to see results?",

        answer:
          "You may see early engagement in 1–2 months, while stronger lead and sales results usually build over 3–6 months.",
      },

      {
        question: "What is your main keyword focus?",

        answer:
          "We naturally optimise around phrases like 'social media marketing services', 'social media marketing agency in India', and 'Instagram marketing services'.",
      },
    ],

    cta: {
      title: "Ready to Grow Your Social Presence?",

      description:
        "Let’s create engaging social media strategies that drive reach, engagement, and conversions.",

      buttonText: "Book Consultation",
    },

    seo: {
      metaTitle: "Social Media Marketing Services | Nextoric Digital",

      metaDescription:
        "Professional social media marketing services in India including content creation, paid ads, Instagram marketing, and performance reporting.",
    },
  },
  {
    slug: "performance-marketing",

    hero: {
      badge: "Performance Marketing",

      title: "Nextoric Digital – Performance Marketing Services",
      image: perM,

      description:
        "Nextoric Digital offers results-driven performance marketing services in India for startups, SMEs, and growth-focused brands. We design and manage paid campaigns that focus on measurable outcomes—leads, sales, app installs, and revenue.",
    },

    sections: [
      {
        heading: "What We Do – Performance Marketing",

        content:
          "As a performance marketing agency in India, we focus on data-driven campaigns that deliver clear ROI.",

        points: [
          "Planning and executing performance-first digital campaigns",

          "Managing Google Ads, Meta Ads, LinkedIn Ads, and other paid channels",

          "Creating high-converting ad creatives, landing pages, and funnels",

          "Setting up tracking, pixels, and conversion goals",

          "Analysing performance and optimising budgets in real time",
        ],
      },

      {
        heading: "Paid Ads That Actually Convert",

        content:
          "We build conversion-focused ad campaigns across multiple paid platforms.",

        points: [
          "Google Ads (Search & Display) for high-intent traffic and remarketing",

          "Meta Ads (Facebook & Instagram) for leads, sales, and awareness",

          "LinkedIn Ads for B2B, SaaS, and professional-service leads",

          "Other performance channels depending on your audience and goals",
        ],
      },

      {
        heading: "Landing Pages & Conversion Optimisation",

        content:
          "Traffic is only valuable if it converts. We optimise landing pages and funnels for measurable business outcomes.",

        points: [
          "High-converting landing pages focused on one clear goal",

          "Benefits-driven copy and trust-building design",

          "Fast loading, mobile-responsive layouts",

          "A/B testing for headlines, forms, and CTAs",
        ],
      },

      {
        heading: "Tracking, Analytics & ROI Reporting",

        content:
          "We set up robust analytics and conversion tracking so you always know what’s working.",

        points: [
          "Conversion tracking for leads, sales, and calls",

          "UTM tagging and campaign-level analytics",

          "Attribution insights across channels and devices",

          "Monthly performance reports with recommendations",
        ],
      },
    ],

    whyChooseUs: [
      {
        title: "Full-Funnel Performance Strategy",

        description:
          "We treat every campaign as a funnel—from awareness to conversion—so every budget dollar supports your business goals.",
      },

      {
        title: "Agile, Data-Driven Optimisation",

        description:
          "We continuously test creatives, audiences, and landing pages to improve ROI over time.",
      },

      {
        title: "Aligned with Your SEO & Organic Growth",

        description:
          "Our performance marketing campaigns complement SEO, social media, and website traffic strategies.",
      },
    ],

    faq: [
      {
        question: "What performance marketing services do you offer?",

        answer:
          "We offer paid search, paid social, remarketing, landing page creation, tracking setup, and full-funnel performance campaigns.",
      },

      {
        question: "Which platforms do you manage?",

        answer:
          "We primarily manage Google Ads, Meta Ads (Facebook & Instagram), LinkedIn Ads, and other paid channels based on your audience.",
      },

      {
        question: "Do you only serve clients in Bengaluru?",

        answer:
          "No. We work remotely with startups, SMEs, and agencies across India.",
      },

      {
        question: "Can you focus only on leads or only on sales?",

        answer:
          "Yes. We create campaigns focused on lead generation, e-commerce sales, app installs, or awareness depending on your goals.",
      },

      {
        question: "How quickly can I see results?",

        answer:
          "Initial data usually appears in 1–2 weeks, while campaign optimisation and scaling generally happen over 1–3 months.",
      },

      {
        question: "What is your main keyword focus?",

        answer:
          "We naturally optimise around phrases like 'performance marketing services', 'performance marketing agency in India', and 'paid ads that deliver results'.",
      },
    ],

    cta: {
      title: "Ready to Scale with Performance Marketing?",

      description:
        "Let’s create high-converting campaigns that drive leads, sales, and measurable ROI for your business.",

      buttonText: "Book Consultation",
    },

    seo: {
      metaTitle: "Performance Marketing Services | Nextoric Digital",

      metaDescription:
        "Results-driven performance marketing services in India including Google Ads, Meta Ads, landing page optimisation, and ROI-focused campaigns.",
    },
  },

  {
    slug: "online-reputation-management",

    hero: {
      badge: "Online Reputation Management",

      title: "Nextoric Digital – Online Reputation Management Services",
      image: onlineR,

      description:
        "Nextoric Digital provides professional online reputation management services in India for startups, SMEs, and service-based brands. We help you build, protect, and improve your digital image across search engines, social media, and review platforms.",
    },

    sections: [
      {
        heading: "What We Do – Online Reputation Management",

        content:
          "As an online reputation management agency in India, we take a proactive approach to how your brand appears online.",

        points: [
          "Monitoring your brand mentions on Google, social media, and review sites",

          "Managing and responding to Google reviews, Facebook reviews, and industry-specific platforms",

          "Creating and promoting positive content to push down negative results",

          "Handling crisis situations with careful communication and cleanup",

          "Tracking your reputation health and improving online sentiment over time",
        ],
      },

      {
        heading: "Google Reviews & Local Reputation",

        content:
          "Google reviews heavily influence customer decisions for local businesses and service brands.",

        points: [
          "Encourage happy customers to leave positive Google reviews",

          "Respond professionally to positive and negative reviews",

          "Identify and flag fake or spam reviews",

          "Build review-rich profiles that improve trust and local rankings",
        ],
      },

      {
        heading: "Social Media & Brand Image Management",

        content:
          "We manage your brand reputation across social platforms to maintain trust and professionalism.",

        points: [
          "Monitoring comments, messages, and mentions",

          "Creating a professional and consistent tone in replies",

          "Highlighting positive feedback and testimonials",

          "Coordinating with your team during PR or crisis situations",
        ],
      },

      {
        heading: "Content & SEO Strategy for Reputation",

        content:
          "We combine content marketing and SEO with reputation management to build long-term authority.",

        points: [
          "Push down negative or outdated pages with fresh positive content",

          "Build authority through case studies and expert blogs",

          "Optimise pages for 'brand + city' searches",

          "Improve overall brand sentiment in search results",
        ],
      },
    ],

    whyChooseUs: [
      {
        title: "Proactive, Not Just Reactive",

        description:
          "We continuously monitor and manage your reputation so issues are caught early and handled calmly.",
      },

      {
        title: "Transparent Communication",

        description:
          "We keep you informed with clear reporting, updates, and actionable recommendations.",
      },

      {
        title: "Aligned with SEO & Marketing",

        description:
          "Your reputation management strategy works alongside SEO, local SEO, and digital marketing efforts.",
      },
    ],

    faq: [
      {
        question: "What online reputation management services do you offer?",

        answer:
          "We offer brand monitoring, review management, positive content promotion, response strategies, and crisis-support services.",
      },

      {
        question: "Do you only handle Google reviews?",

        answer:
          "No. We manage Google, Facebook, and other review platforms along with social media mentions and comments.",
      },

      {
        question: "Do you remove negative reviews?",

        answer:
          "We cannot remove genuine negative reviews, but we help respond professionally, flag fake reviews, and improve your overall reputation score.",
      },

      {
        question: "Do you only serve clients in Bengaluru?",

        answer:
          "No. We work remotely with startups, SMEs, and service-based brands across India.",
      },

      {
        question: "How long does reputation management take to show results?",

        answer:
          "You may notice improvements within 1–3 months, while long-term reputation recovery can take 3–6 months depending on the situation.",
      },

      {
        question: "What is your main keyword focus?",

        answer:
          "We naturally optimise around phrases like 'online reputation management services', 'online reputation management agency in India', and 'manage your brand reputation online'.",
      },
    ],

    cta: {
      title: "Ready to Strengthen Your Online Reputation?",

      description:
        "Let’s build a trustworthy and credible digital presence that customers can rely on.",

      buttonText: "Book Consultation",
    },

    seo: {
      metaTitle: "Online Reputation Management Services | Nextoric Digital",

      metaDescription:
        "Professional online reputation management services in India including review management, brand monitoring, reputation recovery, and SEO-focused reputation strategies.",
    },
  },
  {
    slug: "content-development",

    hero: {
      badge: "Content Development",

      title: "Nextoric Digital – Content Development Services",
      image: contentD,

      description:
        "Nextoric Digital offers professional content development services in India for startups, SMEs, and service-based brands. We create reader-first, SEO-friendly content that attracts organic traffic, builds trust, and turns visitors into leads and customers.",
    },

    sections: [
      {
        heading: "What We Do – Content Development",

        content:
          "As a content development agency in India, we focus on strategic content that supports your business goals.",

        points: [
          "Planning a content strategy based on your audience, keywords, and funnel",

          "Creating blogs, articles, guides, and explainers that answer user questions",

          "Writing and optimising service pages, landing pages, and pillar content",

          "Building topic clusters and internal links to improve SEO and authority",

          "Editing and proofreading all content for clarity, tone, and brand voice",
        ],
      },

      {
        heading: "SEO-Friendly Blog & Article Writing",

        content:
          "We create SEO-friendly blog posts and articles that rank in search and keep readers engaged.",

        points: [
          "Keyword research and natural keyword placement",

          "Clear headings, subheadings, and easy-to-scan content",

          "Answering 'how to', 'what is', and comparison-style queries",

          "Refreshing and updating older content to maintain rankings",
        ],
      },

      {
        heading: "Service & Landing Page Content",

        content:
          "We craft high-converting service and landing page content that clearly explains your offers and drives action.",

        points: [
          "Benefit-driven headlines and clear value propositions",

          "Structured sections like 'What we do', 'Why choose us', and FAQs'",

          "CTAs that guide visitors to enquiry forms, calls, or purchases",

          "Content aligned with SEO and performance marketing campaigns",
        ],
      },

      {
        heading: "Educational & Brand-Building Content",

        content:
          "We create educational and brand-focused content that builds trust and authority in your niche.",

        points: [
          "How-to guides, checklists, and templates",

          "Case studies and success stories",

          "Industry insights and trend-based articles",

          "Email newsletters and social-friendly content snippets",
        ],
      },
    ],

    whyChooseUs: [
      {
        title: "Strategic, Goal-Focused Content",

        description:
          "We create content marketing strategies that support SEO, lead generation, and brand awareness.",
      },

      {
        title: "Human-First, SEO-Friendly Writing",

        description:
          "All content is researched, human-written, and human-edited with natural keyword placement.",
      },

      {
        title: "Aligned with SEO & Digital Marketing",

        description:
          "Your content marketing campaigns work seamlessly with SEO, social media, and performance marketing efforts.",
      },
    ],

    faq: [
      {
        question: "What content marketing services do you offer?",

        answer:
          "We offer SEO blogs, website content, service pages, landing pages, guides, case studies, and email-ready content.",
      },

      {
        question: "Do you write only in English?",

        answer:
          "Yes. We primarily create professional English content tailored for Indian audiences and local search intent.",
      },

      {
        question: "Do you only serve clients in Bengaluru?",

        answer:
          "No. We work remotely with startups, SMEs, and service brands across India.",
      },

      {
        question: "Can you optimise my existing content?",

        answer:
          "Yes. We audit, rewrite, update, and optimise existing content for better SEO, readability, and conversions.",
      },

      {
        question: "How long does content marketing take to show results?",

        answer:
          "You may start seeing improved rankings and traffic within 2–4 months, while stronger authority and lead generation grow over 6+ months.",
      },

      {
        question: "What is your main keyword focus?",

        answer:
          "We naturally optimise around phrases like 'content marketing services', 'content marketing agency in India', and 'SEO-friendly content marketing'.",
      },
    ],

    cta: {
      title: "Ready to Grow with Content Marketing?",

      description:
        "Let’s create SEO-friendly, conversion-focused content that builds authority, traffic, and leads for your business.",

      buttonText: "Book Consultation",
    },

    seo: {
      metaTitle: "Content Marketing Services | Nextoric Digital",

      metaDescription:
        "Professional content marketing services in India including SEO blogs, landing page content, content strategy, and brand-focused content creation.",
    },
  },
];

export default servicesData;
